import { fonts, googleFonts } from '../assets';
import type { FontSelectionMap } from '../types';

export function computeFont(fontFamily?: keyof FontSelectionMap) {
  if (fontFamily) {
    if (fontFamily in fonts) {
      const fontType = googleFonts[fontFamily]?.category;
      return `"${fonts[fontFamily]}", ${fontType === 'serif' ? 'ui-serif, serif' : 'system-ui, sans-serif'}`;
    }

    // If nothing exists in default fonts mapping, render font family option as is
    return `"${fontFamily}", system-ui, sans-serif`;
  }

  return undefined;
}
